import * as React from 'react'
import { designTokens } from '../../lib/design-tokens'

type IconProps = React.SVGProps<SVGSVGElement> & {
  color?: string
  strokeWidth?: number
}

export const ChevronDownIcon = ({
  width = 24,
  height = 24,
  color = designTokens.colors.text.primary,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M5 9L11.2191 14.3306C11.6684 14.7158 12.3316 14.7158 12.7809 14.3306L19 9"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
)

ChevronDownIcon.displayName = 'ChevronDownIcon'
